import { required } from "ra-core";
import { TextInput } from "@/components/admin/text-input";

/**
 * The four fields of a company: name, address, invoice e-mail and remarks.
 */
export const CompanyInputs = () => (
  <div className="flex flex-col gap-4 p-1">
    <TextInput
      source="name"
      className="w-full h-fit"
      validate={required()}
      helperText={false}
    />
    <TextInput source="address" helperText={false} />
    <TextInput
      source="invoice_email"
      helperText="resources.companies.helper.invoice_email"
    />
    <TextInput source="description" multiline rows={5} helperText={false} />
  </div>
);
